import React from 'react';
import cx from 'classnames';

import Icon from '../../../../../../../common/general/Icon';
import { scPurple80 } from '../../../../../../../constants/systemColors';
import { isLogAvailableForReviewCycle } from '../../../../Patients/Logs/LogsPageServices';
import { DATA_COLLECTED, NO_DATA_TO_COLLECT } from '../../../EncounterDescNew/LogCheck/LogCheckNew';
import { getIcon, getIconSuit } from '../../reviewService';

import './ReviewSidebarItem.scss';

export default function ReviewSidebarItem({
  name,
  type,
  loading,
  isNotPerformed = false,
  isDisabled = true,
  onClick,
  logCheckSnapshotReviewState,
  item
}) {
  const showNotPerformedIcon = isNotPerformed;

  function ignoreDisabledOnClick(item) {
    if (!isDisabled && !loading) {
      return onClick(item);
    } else {
      return () => {};
    }
  }

  return (
    <>
      {
        <div
          onClick={ignoreDisabledOnClick}
          className={cx('eds-review-sidebar-item', {
            'eds-review-sidebar-item-disabled': isDisabled || loading
          })}
        >
          <div className="eds-review-sidebar-item-icon">
            {loading ? (
              <span className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </span>
            ) : (
              <Icon suit={getIconSuit(type)}>{getIcon(type)}</Icon>
            )}
          </div>
          <div className="eds-review-sidebar-name-and-icon">
            <div className="eds-review-sidebar-item-name" title={name}>
              {name}
              {type === 'LogChecks' && isLogAvailableForReviewCycle(item.domainCode) && (
                <div style={{ color: scPurple80, fontWeight: 'bold' }}>
                  {logCheckSnapshotReviewState?.logCheckSnapshotState?.encounterLogCheckSnapshotKey?.rowType ===
                  DATA_COLLECTED
                    ? `${item.domainCode} Reported`
                    : logCheckSnapshotReviewState?.logCheckSnapshotState?.encounterLogCheckSnapshotKey?.rowType ===
                        NO_DATA_TO_COLLECT && `NO ${item.domainCode} Reported`}
                </div>
              )}
            </div>
            {getIconStatusOfItemGroup()}
          </div>
        </div>
      }
    </>
  );

  function getIconStatusOfItemGroup() {
    if (!loading && showNotPerformedIcon) {
      return <div className="eds-review-sidebar-item-not-performed-icon">NP</div>;
    }
  }
}
